import request from '@/utils/axios.js';

export async function getBusAdminList() {
  return request.get('/bus-admin/web/admin-web-menu/getAllModuleByWeb');
}

export async function getBannerList(data) {
  return request.post('/bus-admin/web/home/getBannerList', data);
}

export async function getContentByMenuList(data) {
  return request.post('/bus-admin/web/home/getContentByMenuList', data);
}

// 通过二级菜单分页查询文章
export async function getContentBuTwo(data) {
  return request.post(`/bus-admin/web/home/getContentBuTwo`, data);
}
export async function getArticleContent(data) {
  return request.get(`/bus-admin/web/home/webGetArticleById/${data.id}`);
}

export async function getDonationDynamics() {
  return request.get(`/bus-admin/web/home/getDonationDynamics`);
}

export async function getPeopleList(data) {
  return request.post(`/bus-admin/web/admin-web-static/getPeopleList`, data);
}

export async function getAwardList(data) {
  return request.post(`/bus-admin/web/admin-web-static/getAwardList`, data);
}

export async function getOrderPageList(data) {
  return request.post(`/bus-admin/web/admin-order/getOrderPageList`, data);
}

export async function getWebPageList(data) {
  return request.post(`/bus-admin/web/admin-web-publicity/webPage`, data);
}

export async function getDataById(data) {
  return request.get(`/bus-admin/web/admin-web-publicity/getDataById/${data.id}`);
}

export async function insertMsg(data) {
  return request.post(`/bus-admin/web/admin-message/insert`, data);
}

export async function sendVeriftcationCode(data) {
  return request.post(`/bus-admin/web/home/sendVeriftcationCode`, data);
}

export async function getContentList(data) {
  return request.get(`/bus-admin/web/home/getContentList`);
}

export async function activitySignUp(data) {
  return request.post(`/bus-admin/web/admin-web-activity/signUp`, data);
}

export async function getPageList(data) {
  return request.post(`/bus-admin/web/home/getPageList`, data);
}
export async function getDonProject(data) {
  return request.post(`/bus-admin/web/home/getDonProject`, data);
}

// 获取微信 JS SDK 签名配置（需后端实现该接口）
export async function getWxJsConfig(data) {
  // 约定：后端从参数 url 生成签名
  return request.post(`/bus-admin/web/wechat/js-sdk-config`, data, { ignoreLoading: true });
}


